import gql from 'graphql-tag';

export const setAwardStatusMutation = gql`
    mutation setAwardStatusMutation($id: ID!, $status: AwardStatus!) {
        results: awardSetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;